import { useState, useEffect } from 'react';

const locale2lang: Record<string, string> = {
  'so-SO': 'Af-Soomaali',
  'af-ZA': 'Afrikaans',
  'az-AZ': 'Azərbaycan dili',
  'id-ID': 'Bahasa Indonesia',
  'ms-MY': 'Bahasa Melayu',
  //'jv-ID': 'Basa Jawa',
  //'cx-PH': 'Bisaya',
  'bs-BA': 'Bosanski',
  //'br-FR': 'Brezhoneg',
  'ca-ES': 'Català',
  'cs-CZ': 'Čeština',
  'co-FR': 'Corsu',
  'cy-GB': 'Cymraeg',
  'da-DK': 'Dansk',
  'de-DE': 'Deutsch',
  'et-EE': 'Eesti',
  'en-US': 'English (US)',
  'en-GB': 'English (UK)',
  'es-ES': 'Español (Spain)',
  'es-MX': 'Español (Mexico)',
  'eu-ES': 'Euskara',
  'tl-PH': 'Filipino',
  //'fo-FO': 'Føroyskt',
  'fr-CA': 'Français (Canada)',
  'fr-FR': 'Français (France)',
  'fy-NL': 'Frysk',
  'ga-IE': 'Gaeilge',
  'gl-ES': 'Galego',
  //'gn-PY': 'Guarani',
  'ha-NG': 'Hausa',
  'hr-HR': 'Hrvatski',
  //'rw-RW': 'Ikinyarwanda',
  'is-IS': 'Íslenska',
  'it-IT': 'Italiano',
  'sw-KE': 'Kiswahili',
  'ht-HT': 'Kreyòl Ayisyen',
  'ku-TR': 'Kurdî (Kurmancî)',
  'lv-LV': 'Latviešu',
  'lt-LT': 'Lietuvių',
  'la-VA': 'lingua latina',
  'hu-HU': 'Magyar',
  'mg-MG': 'Malagasy',
  'mt-MT': 'Malti',
  'nl-NL': 'Nederlands',
  'nl-BE': 'Nederlands (België)',
  //'nb-NO': 'Norsk (bokmål)',
  //'nn-NO': 'Norsk (nynorsk)',
  'uz-UZ': "O'zbek/Uzbek",
  'pl-PL': 'Polski',
  'pt-BR': 'Português (Brasil)',
  'pt-PT': 'Português (Portugal)',
  //'ff-NG': 'Pulaar',
  'ro-RO': 'Română',
  //'sc-IT': 'Sardu',
  'sn-ZW': 'Shona',
  'sq-AL': 'Shqip',
  //'sz-PL': 'ślōnskŏ gŏdka',
  'sk-SK': 'Slovenčina',
  'sl-SI': 'Slovenščina',
  'fi-FI': 'Suomi',
  'sv-SE': 'Svenska',
  'vi-VN': 'Tiếng Việt',
  'tr-TR': 'Türkçe',
  //'zz-TR': 'Zaza',
  'el-GR': 'Ελληνικά',
  'be-BY': 'Беларуская',
  'bg-BG': 'Български',
  'ky-KG': 'кыргызча',
  'kk-KZ': 'Қазақша',
  'mk-MK': 'Македонски',
  'mn-MN': 'Монгол',
  'ru-RU': 'Русский',
  'sr-RS': 'Српски',
  'tg-TJ': 'Тоҷикӣ',
  'uk-UA': 'Українська',
  'ka-GE': 'ქართული',
  'hy-AM': 'Հայերեն',
  //'he-IL': '‏עברית‏',
  'ur-PK': '‏اردو‏',
  'ar-AR': '‏العربية‏',
  'ps-AF': '‏پښتو‏',
  'fa-IR': '‏فارسی‏',
  //'cb-IQ': '‏کوردیی ناوەندی‏',
  //'sy-SY': '‏ܣܘܪܝܝܐ‏',
  //'tz-MA': 'ⵜⴰⵎⴰⵣⵉⵖⵜ',
  'am-ET': 'አማርኛ',
  'ne-NP': 'नेपाली',
  'mr-IN': 'मराठी',
  'hi-IN': 'हिन्Hindi',
  //'as-IN': 'অসমীয়া',
  'bn-IN': 'বাংলা',
  'pa-IN': 'ਪੰਜਾਬੀ',
  'gu-IN': 'ગુજરાતી',
  //'or-IN': 'ଓଡ଼ିଆ',
  'ta-IN': 'தமிழ்',
  'te-IN': 'తెలుగు',
  'kn-IN': 'ಕನ್ನ',
  'ml-IN': 'മലയാളം',
  'si-LK': 'සිංහල',
  'th-TH': 'ภาษาไทย',
  'lo-LA': 'ພາສາລາວ',
  'my-MM': 'မြန်မာဘာ',
  'km-KH': 'ភាសាខ្មែ',
  'ko-KR': '한국어',
  'zh-TW': '中文(台灣)',
  'zh-CN': '中文(简体)',
  'zh-HK': '中文(香港)',
  'ja-JP': '日本語',
  'ja-KS': '日本語(関西)',
};

const STORE_KEY = 'BSpeechLocale2';

export const useVoiceSetting = () => {
  const [selectedLocale, setSelectedLocale] = useState<string>();
  const [localeList, setLocaleList] = useState<Array<{ lang: string; locale: string }>>([]);

  const updateLocale = (selectLocale: string) => {
    const currentLocale = localStorage.getItem(STORE_KEY);
    if (currentLocale !== selectLocale) {
      try {
        localStorage.setItem(STORE_KEY, selectLocale);
        setSelectedLocale(selectLocale);
      } catch (e) {
        BLog.warn('[SpeechManager] localStorage.setItem error:', e);
      }
    }
  };

  useEffect(() => {
    let isMounted = true;

    const getLocaleData = () => {
      let curLocale = localStorage.getItem(STORE_KEY);
      if (curLocale == null) {
        BLog.log('[SpeechManager] No saved locale. Use navigator.language = ' + navigator.language);
        curLocale = navigator.language;
      } else {
        BLog.log('[SpeechManager] Saved locale = ' + curLocale);
      }

      Device.getSpeechRecognizerSupportedLocales((json: any) => {
        if (!isMounted) return;

        if (!json) {
          BLog.warn('[SpeechManager] No supported locale. Use navigator.language = ' + navigator.language);
          json = `["${navigator.language}"]`;
        }
        const languageData = JSON.parse(json); // ex: ['af-ZA', 'az-AZ']
        const shortLocaleList: Record<string, string> = {}; // ex: {so: 'so-SO', af: 'af-ZA'}
        const selectedList: string[] = []; // ex: ['af-ZA', 'az-AZ'] 에서 -> 바뀜 ['Afrikaans:af-ZA', 'Azərbaycan dili:az-AZ']

        for (const locale in locale2lang) {
          const localeKey = locale.substring(0, 2);
          if (!Object.prototype.hasOwnProperty.call(shortLocaleList, localeKey)) {
            shortLocaleList[localeKey] = locale;
          }
        }

        for (const locale of languageData) {
          if (!Object.prototype.hasOwnProperty.call(locale2lang, locale)) {
            const localeKey = locale.substring(0, 2);
            const localeValue = shortLocaleList[localeKey];
            if (localeValue == null) {
              BLog.warn('[SpeechManager] Cant find language, locale=', locale);
              continue;
            }
          }
          if (selectedList.indexOf(locale) < 0) {
            selectedList.push(locale);
          }
        }

        if (curLocale && !selectedList.includes(curLocale)) {
          const candidate = shortLocaleList[curLocale.substring(0, 2)];
          if (candidate == null) {
            BLog.warn('[SpeechManager] curLocale is not in the supported list. Use en-US');
            curLocale = 'en-US';
          } else {
            BLog.warn('[SpeechManager] curLocale is not in the supported list. Use similar locale:', candidate);
            curLocale = candidate;
          }
        }

        for (let i = 0; i < selectedList.length; i++) {
          selectedList[i] = locale2lang[selectedList[i]] + ':' + selectedList[i];
        }
        selectedList.sort();

        const languageOptions = selectedList.map((item) => {
          const [lang, locale] = item.split(':');
          return { lang: lang, locale: locale };
        });

        setSelectedLocale(curLocale || 'en-US');
        setLocaleList(languageOptions);
      });
    };

    getLocaleData();

    return () => {
      isMounted = false;
    };
  }, []);

  const filteredLocaleList = localeList.filter((item) => item.lang !== 'undefined' && item.locale !== selectedLocale);
  const filteredCurrentLocale = localeList.find((item) => item.locale === selectedLocale)?.lang;

  return {
    selectedLocale,
    updateLocale,
    filteredLocaleList,
    filteredCurrentLocale,
  };
};

export default useVoiceSetting;